import { EnvironmentInjector, Injectable, inject, runInInjectionContext } from '@angular/core';
import { Functions, httpsCallableData } from '@angular/fire/functions';
import { firstValueFrom } from 'rxjs';
import { LIB_CONFIG } from '../lib-config';

type ApiBase = 'default' | 'files' | 'hl';

@Injectable({ providedIn: 'root' })
export class ApiServerService {
  private readonly injector = inject(EnvironmentInjector);
  private readonly functions = inject(Functions);
  private readonly libConfig = inject(LIB_CONFIG);

  readonly apiBaseMap: Record<ApiBase, string> = {
    default: this.libConfig.apiUrl,
    files: this.libConfig.apiFilesUrl,
    hl: this.libConfig.apiHl
  };

  /**
   * Realiza una llamada genérica a una Firebase Function.
   * @template TRes - Tipo de respuesta (Response)
   * @template TReq - Tipo de entrada (Request)
   */
  async call<TRes = unknown, TReq = any>(segment: string, data: TReq = null, base: ApiBase = 'default'): Promise<TRes> {

    const baseUrl = this.apiBaseMap[base];
    const path = `${baseUrl}/${segment}`;

    // TODO: quitar este bloque parche una vez que Firebase arregle el error "inject() may only be used during injection" al usar httpsCallableData fuera de un contexto de inyección (como en un servicio)
    return runInInjectionContext(this.injector, () => {
      const callable = httpsCallableData<TReq, TRes>(this.functions, path, {
        timeout: 60_000
      });
      return firstValueFrom(callable(data as TReq));
    });

    // TODO: este bloque de abajo es el bueno, el de arriba es un parche para evitar el error "inject() may only be used during injection" al usar httpsCallableData fuera de un contexto de inyección (como en un servicio)
    // // Al pasar <TReq, TRes>, tipamos la entrada y la salida del callable
    // const callable = httpsCallableData<TReq, TRes>(this.functions, path, {
    //   timeout: 60_000
    // });

    // // Ejecutamos y convertimos a Promesa (one-shot)
    // return firstValueFrom(callable(data as TReq));
  }

  /**
   * Especialización para búsquedas en ElasticSearch
   */
  async search<TRes>(options: SearchModel | Array<SearchModel>): Promise<TRes> {
    const query = Array.isArray(options) ? { queries: options } : options;
    return this.call<TRes>('search', query);
  }
}

export interface SearchModel {
  index: string;
  body: Object;
}

//TODO Hacer manejo genérico de errores (ver ejemplo utils-api)
export interface ApiError {
  code: string;
  details: any;
  message: string;
}

export const API_ERROR_CODES = [
  'invalid-argument',
  'unauthenticated',
  'permission-denied',
  'not-found',
  'already-exists',
  'failed-precondition',
  'internal',
  'unimplemented',
  'unavailable',
  'deadline-exceeded'
];

export const API_SERVICES = ['functions'];

export const getApiErrorCode = (code) => code.split('/')[1];
